export function register() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .catch((erro) => console.error('Falha ao registrar o Service Worker:', erro));
  });
}

export function unregister() {
  if (!('serviceWorker' in navigator)) return;

  navigator.serviceWorker.ready
    .then((registration) => registration.unregister())
    .catch((erro) => console.error('Falha ao desregistrar o Service Worker:', erro));
}
